import clsx from "clsx";
import RecordsGallery from "@/components/records/records-gallery/records-gallery";
import RecordsNav from "@/components/records/records-nav/records-nav";


export default function RecordsGalleryPage({ isDummy = false, introCards, allCards, catId, introCategory }) {
  return (
    <div className={clsx("w-full font-sans page", isDummy && 'pointer-events-none')}>
      <RecordsGallery isDummy={isDummy} recordCategoryType="featured" hasColParallax={false} isTopSection={true} blurredDecorationStartIndex={4} blurredDecorationCount={4} slug={catId} cards={introCards} title={introCategory.title} label={introCategory.label} intro={introCategory.intro} theme="main-dark" introClassName="w-full max-md:px-(--space-6) md:max-w-[30rem] xl:max-w-[36rem]" />
      {!isDummy && <RecordsNav currentCategory={catId} />}
      {!isDummy && <RecordsGallery recordCategoryType="all" headingLevel="h2" blurredDecorationCount={15} blurredDecorationStartIndex={8} slug={catId} cards={allCards} title="All Stories" intro="Dive into our collection of untold stories from across the land." introClassName="max-lg:w-[90%] max-w-[28.125rem]" />}
    </div>
  )
}